import React from 'react';

import { CorporateSubscriberCirclePartner } from '../../utils/backend-api/partners';
import CorporateSubscriberCircleCard from './CorporateSubscriberCircleCard';

const CorporateSubscriberCircleContainer = ({
  cscPartners,
}: {
  cscPartners: CorporateSubscriberCirclePartner[];
}) => {
  return (
    <>
      <div className="tw-flex tw-justify-between tw-items-center tw-w-full tw-px-20 sm:tw-p-0">
        <h3 className="tw-mr-20 tw-text-primary-red tw-font-black tw-text-[18px] tw-font-['Meta',Georgia,sans-serif] tw-whitespace-nowrap">
          <span className="tw-hidden sm:tw-inline">The Information </span>Subscriber Council
        </h3>
        <div className="tw-bg-pro-red tw-w-full tw-h-2"></div>
      </div>
      <div className="tw-mt-0 tw-mb-40 tw-px-20 sm:tw-mt-12 sm:tw-mb-48 sm:tw-p-0 sm:tw-grid sm:tw-grid-cols-2">
        {cscPartners.map((partner) => (
          <CorporateSubscriberCircleCard key={`csc-card-${partner.id}`} partner={partner} />
        ))}
        <a
          className="tw-text-[14px] tw-font-['Meta',Georgia,sans-serif] tw-underline tw-pl-12 tw-py-3 tw-border-0 tw-border-l tw-border-[#c4c6ce] tw-border-solid"
          href="/partners#partnerships"
        >
          Learn More
        </a>
      </div>
    </>
  );
};

export default CorporateSubscriberCircleContainer;
